import Fee from "./Fee"
import Installment from "./Installment"
import Order from "../../Shared/Models/Order"

export default class ApplicationModel {
    applicationId: number
    examinationId: number
    balance: number
    orderNumber: string
    examLateFee: Fee
    totalFeeAmount: number
    totalExamFeeAmount: number
    fees: Array<Fee>
    hasAttested: boolean
    needsFinalReview: boolean
    attestationContent: string
    installmentOptions: Array<Installment>
    createdDate: string
    isAdaRequested: boolean
    isNmaRequested: boolean
    isTransferredIn: boolean;
    isSplitPay: boolean;
    candidateStatusDescription: string;
    candidateStatusReason: string;
    candidateStatus: CandidateStatus;
    knownCandidateStatusReason: KnownCandidateStatusReason;
    modularCertificationIds: Array<number>
    order: Order;
    cnpType: number
    extensionDate: string;
    hasDeadlineException: boolean;
}

export enum CandidateStatus {
    ToBeReviewed = 1,
    Hold = 2,
    Denied = 3,
    Approved = 4,
    TransferredOut = 5,
    Withdrawn = 6,
    InviteSent = 7,
    Unsubmitted = 8
}

export enum KnownCandidateStatusReason {
    Withdrew = 9
}
